// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__3gXxw","main-image":"Header_main-image__3TPn3"};